import React from 'react'
export const Tires = {
  title: 'Examples of Damage',
  content: [
    {
      src: 'https://file.kbb.com/kbb/images/ico/condition/quarterTest.svg',
      title: 'How to Check for Worn Tire Tread',
      text: (
        <div className="padding-vertical-md">
          <div>
            <strong>Step 1:</strong> Insert a quarter head down into the grooves of your tire.
          </div>
          <div>
            <strong>Step 2:</strong> Determine tread depth.
          </div>
          <div className="padding-horizontal-md padding-vertical-lg">
            <div>Tires need replacement if there is additional space visible between Washington’s head and the tire.</div>
          </div>
          <a href="https://file.kbb.com/kbb/images/ico/conditionRedesign/exterior/20180719ConditionTool.pdf" target="_target" className="modal-pdf-link">
            See the printable reference tool.
          </a>
        </div>
      ),
    },
    {
      title: 'Worn Tires (Need Replacement)',
      text: 'Tires need replacing if there is additional space visible between Washington’s head and the tire.',
    },
    {
      title: 'Scratched Rims',
      text: 'Minor surface damage and/or light scuffs of all sizes caused most often by impact from curbs or debris.',
    },
    {
      title: 'Bent Rims',
      text: 'Major dents or structural damage to the rim’s outer edge that causes tires to leak or blow out.',
    },
  ],
}
